// mainRoutes.js
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
import AdminRoute from './AdminRoute';

// Components
import Home from '../components/Home';
import TournamentHome from '../components/TournamentHome';
import Divisions from '../components/Divisions';
import Teams from '../components/Teams';
import Tournaments from '../components/Tournaments';
import Schedules from '../components/Schedules';
import Standings from '../components/Standings';
import Scores from '../components/Scores';
import WildCard from '../components/WildCard';
import Playoff from '../components/Playoff';
import Feedback from '../components/Feedback';
import HomeFeedback from '../components/HomeFeedback';
import Documents from '../components/documents'
import Share from '../components/Share';
import Contact from '../components/Contact';

//Auth Components
import RegisterForm from '../components/auth/RegisterForm';
import VerifyEmail from '../components/auth/VerifyEmail';
import Login from '../components/auth/Login';
import Profile from '../components/auth/Profile';
import Unauthorized from '../components/auth/Unauthorized';
import AddTournament from '../components/auth/AddTournament';


//Admin Components
import Admin from '../components/admin/Admin';
import UpdateTournament from '../components/admin/UpdateTournament';
import ManageStandardPlayoff from '../components//admin/ManageStandardPlayoff';
import ManagePlayoff from '../components/admin/ManagePlayoff';
import ManageCustomPlayoff from '../components/admin/ManageCustomPlayoff';
import ManageKPSNAPlayoff from '../components/admin/ManageKPSNAPlayoff';
import AddPlayoffGame from '../components/admin/AddPlayoffGame';
import AddDivision from '../components/admin/AddDivision';
import ManageDivision from '../components/admin/ManageDivision';
import AddTeam from '../components/admin/AddTeam';
import UpdateTeam from '../components/admin/UpdateTeam';
import UpdateTeamStats from '../components/admin/UpdateTeamStats';
import AddGame from '../components/admin/AddGame';
import ManageGame from '../components/admin/ManageGame';
import UploadGameData from '../components/admin/UploadGameData';
import AddSchedule from '../components/admin/AddSchedule';
import AddScore from '../components/admin/AddScore';
import AdminStandings from '../components/admin/AdminStandings';
import AdminFeedback from '../components/admin/AdminFeedback';
import ManageTeams from '../components/admin/ManageTeams';



export const MainRoutes = () => {
  return (
    <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/feedback" element={<HomeFeedback />} />
            <Route path="/contact" element={<Contact />} />
            
            <Route path="/:linkindex" element={<TournamentHome />} />
            <Route path="/:linkindex/schedules" element={<Schedules />} />
            <Route path="/:linkindex/scores" element={<Scores />} />
            <Route path="/:linkindex/wildcard" element={<WildCard />} />
            <Route path="/:linkindex/playoff" element={<Playoff />} />
            <Route path="/:linkindex/divisions" element={<Divisions />} />
            <Route path="/:linkindex/teams" element={<Teams />} />
            <Route path="/:linkindex/standings" element={<Standings />} />
            <Route path="/:linkindex/feedback" element={<Feedback />} />


            <Route path="/auth/registerform" element={<RegisterForm />} />
            <Route path="/auth/verifyemail" element={<VerifyEmail />} />
            <Route path="/auth/login" element={<Login />} />
            <Route path="/auth/unauthorized" element={<Unauthorized />} />
             <Route path="/auth/profile" element={ <PrivateRoute> <Profile /> </PrivateRoute> } />
            <Route path="/auth/add-tournament" element={  <PrivateRoute>  <AddTournament /> </PrivateRoute>} />

                {/* <Route path="/admin/" element={<Admin />} /> */}
            <Route path="/admin/:linkindex/admin" element={<AdminRoute><Admin />  </AdminRoute>} />
            <Route path="/admin/:linkindex/update-tournament" element={<PrivateRoute> <UpdateTournament /> </PrivateRoute>} />
            <Route path="/admin/:linkindex/add-division" element={<AdminRoute> <AddDivision /> </AdminRoute>} />
            <Route path="/admin/:linkindex/manage-division" element={<AdminRoute> <ManageDivision /></AdminRoute>} />
            <Route path="/admin/:linkindex/add-team" element={<AdminRoute><AddTeam /></AdminRoute>} />
            <Route path="/admin/:linkindex/manage-team" element={<AdminRoute><ManageTeams /></AdminRoute>} />
            <Route path="/admin/:linkindex/update-team" element={<AdminRoute><UpdateTeam /></AdminRoute>} />
            <Route path="/admin/:linkindex/update-teamstats" element={<AdminRoute><UpdateTeamStats /></AdminRoute>} />
            <Route path="/admin/:linkindex/add-game" element={<AdminRoute><AddGame /></AdminRoute>} />
            <Route path="/admin/:linkindex/manage-game" element={<AdminRoute><ManageGame /></AdminRoute>} />
            <Route path="/admin/:linkindex/upload-game" element={<AdminRoute><UploadGameData /></AdminRoute>} />
            <Route path="/admin/:linkindex/add-score" element={<AdminRoute><AddScore /></AdminRoute>} />
            <Route path="/admin/:linkindex/add-playoffgame" element={<AdminRoute><AddPlayoffGame /></AdminRoute>} />
            <Route path="/admin/:linkindex/manage-standardplayoff" element={<AdminRoute><ManageStandardPlayoff /></AdminRoute>} />
            <Route path="/admin/:linkindex/manage-playoff" element={<AdminRoute><ManagePlayoff /></AdminRoute>} />
            <Route path="/admin/:linkindex/manage-customplayoff" element={<AdminRoute><ManageCustomPlayoff /></AdminRoute>} />
            <Route path="/admin/:linkindex/manage-kpsnaplayoff" element={<AdminRoute><ManageKPSNAPlayoff /></AdminRoute>} />
            <Route path="/admin/:linkindex/admin-standing" element={<AdminRoute> <AdminStandings /> </AdminRoute>} />
            <Route path="/admin/:linkindex/admin-feedback" element={<AdminFeedback />} />
            <Route path="/admin/:linkindex/share" element={<Share />} />

           
            
            
            {/* <Route path="/admin/:linkindex/add-schedule" element={<AddSchedule />} /> */}
            <Route path="/loaderio-f566d198e1c407955b1d6cabdfd17307/" element={<Documents />} />
    </Routes>
       
  );
};
